module.exports = __webpack_public_path__ + "media/images/icon_popup_area-8dc5c673c76151d247534d86c74b0882.png";